export enum AbacVisibility {
  GLOBAL = 'GLOBAL',
  PRIVATE = 'PRIVATE'
}
